import { render, staticRenderFns } from "./WidgetHead.vue?vue&type=template&id=7ca36a2e&scoped=true&"
import script from "./WidgetHead.vue?vue&type=script&lang=js&"
export * from "./WidgetHead.vue?vue&type=script&lang=js&"
import style0 from "./WidgetHead.vue?vue&type=style&index=0&id=7ca36a2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca36a2e",
  null
  
)

export default component.exports